import { render, staticRenderFns } from "./RetailScalePoints.vue?vue&type=template&id=e71f398e&scoped=true"
import script from "./RetailScalePoints.vue?vue&type=script&lang=ts"
export * from "./RetailScalePoints.vue?vue&type=script&lang=ts"
import style0 from "./RetailScalePoints.vue?vue&type=style&index=0&id=e71f398e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71f398e",
  null
  
)

export default component.exports